<template>
  <woot-button
    size="medium"
    variant="smooth"
    color-scheme="alert"
    icon="delete"
    :is-disabled="disableDeleteButton"
    @click="deleteAttachments"
  >
    {{ $t('FILE_STORAGE.DELETE.BUTTON') }}
  </woot-button>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters({
      selectedRows: 'fileStorage/getSelectedRows',
    }),
    disableDeleteButton() {
      return this.selectedRows.length === 0;
    },
  },
  methods: {
    async deleteAttachments() {
      try {
        await this.$store.dispatch('fileStorage/deleteAttachments');
        bus.$emit(
          'newToastMessage',
          this.$t('FILE_STORAGE.DELETE.SUCCESS_MESSAGE')
        );
      } catch (e) {
        bus.$emit(
          'newToastMessage',
          this.$t('FILE_STORAGE.DELETE.FAILED_MESSAGE')
        );
      }
    },
  },
};
</script>
